/* BYG RASTER VOLL · 24.10.2026, erweitert 30.10.2026
   Manuel: „Wenn ich auf ‚Mehr anzeigen‘ einmal klicke, dann kommen bei der
   letzten Reihe nur noch drei Produkte, obwohl man natürlich vier platzieren
   sollte.“

   Ursache: Shopify lädt je Seite feste 24 Artikel (6 volle Reihen). Mit
   gemerktem Bike blendet byg-garage.js aber unpassende Teile aus
   (body.byg-nur-passende + .byg-karte--nicht). Von 48 Artikeln waren beim
   Test (KTM 125 SX, 2018) nur 39 sichtbar, die letzte Reihe hatte drei Karten.

   Lösung: Solange „Mehr anzeigen“ noch weitere Seiten hat, hält dieses
   Skript die überzähligen letzten Karten zurück (Klasse byg-raster-rest), so
   dass nur volle Reihen stehen. Beim nächsten Nachladen werden sie wieder
   gezeigt und stehen dann an ihrer richtigen Stelle vor den neuen Artikeln.
   Auf der letzten Seite wird nichts zurückgehalten, dort darf die letzte
   Reihe kurz sein. Spalten werden gemessen (4 am Desktop, 2 am Handy).
   Gibt es weniger sichtbare Karten als eine Reihe, bleibt alles stehen.

   30.10.2026 — SEITE VOLL STATT DREI KARTEN (Manuel, KTM 125 SX 2025,
   Auspuff: „wenn ich auf ‚Mehr‘ drücke, was überhaupt von Haus aus schon
   schlecht ist, werden drei angezeigt und nicht einfach eine Seite voll“):
   - Mit gemerktem Bike lädt das Skript selbst weitere Seiten nach, bis
     24 passende Teile stehen oder es keine Seiten mehr gibt. Ein Klick auf
     „Mehr anzeigen“ heißt dann: 24 passende mehr, nicht 24 Artikel mehr.
     Gezählt wird erst, wenn byg-garage.js alle Karten bewertet hat
     (Ereignis byg:karten). Höchstens 15 Seiten je Schritt.
   - Nachgeladene Karten bleiben unsichtbar (byg-raster-neu), bis
     byg-garage.js sie bewertet hat. Vorher blitzten unpassende Teile kurz
     auf. Fällt die Bewertung aus, werden sie nach 5 s trotzdem gezeigt.
   - Selbst nachgeladene Seiten ersetzen den Verlaufseintrag (replaceState)
     statt neue anzulegen, sonst bräuchte „Zurück“ bis zu 15 Klicks.
   - HAUSMARKE ZUERST wie auf der Bike-Übersicht (byg-bike-teile.liquid):
     beim Zweitakt-Auspuff Doma vor HGS, bei Kolben Vertex usw. Gilt, wenn
     ein Bereich gefiltert ist (filter.p.product_type) oder die Seite
     überwiegend aus einem Bereich besteht (Kategorien wie Auspuff), nicht
     bei eigener Sortierung (sort_by). Was der Kunde schon gesehen hat,
     springt nicht mehr: nach einem Klick auf „Mehr anzeigen“ wird nur der
     neue Teil gereiht. */
(function () {
  'use strict';
  var REST = 'byg-raster-rest', NEU = 'byg-raster-neu';
  var letzte = '';
  var t = null;

  var stil = document.createElement('style');
  stil.textContent = '#data-pagination > .' + REST + ',#data-pagination > .' + NEU + '{display:none!important}';
  document.head.appendChild(stil);

  function weitereSeiten() {
    var b = knopf();
    return !!b && !b.classList.contains('hide');
  }
  function knopf() {
    return document.querySelector('#component-pagination-loader .js-load-more');
  }

  function signatur(grid) {
    var teile = [grid.children.length, weitereSeiten() ? 1 : 0, Math.round(window.innerWidth / 50),
      document.body.classList.contains('byg-nur-passende') ? 1 : 0];
    for (var i = 0; i < grid.children.length; i++) {
      teile.push(Array.prototype.filter.call(grid.children[i].classList, function (c) { return c !== REST; }).join(' '));
    }
    return teile.join('|');
  }

  function fuellen() {
    var grid = document.getElementById('data-pagination');
    if (!grid || !grid.children.length) return;
    gridPruefen(grid);
    sortieren(grid);
    var sig = signatur(grid);
    if (sig === letzte) return;
    letzte = sig;

    var kinder = Array.prototype.slice.call(grid.children);
    kinder.forEach(function (k) { k.classList.remove(REST); });
    if (!weitereSeiten()) return;

    var sichtbar = kinder.filter(function (k) { return k.offsetParent !== null; });
    if (!sichtbar.length) return;
    var breite = sichtbar[0].getBoundingClientRect().width;
    if (!breite) return;
    var spalten = Math.max(1, Math.round(grid.getBoundingClientRect().width / breite));
    var rest = sichtbar.length % spalten;
    if (!rest || sichtbar.length <= spalten) return;
    for (var i = sichtbar.length - rest; i < sichtbar.length; i++) {
      sichtbar[i].classList.add(REST);
    }
  }

  /* ---------- Hausmarke zuerst ---------- */
  var AUSPUFF = ['Doma', 'HGS'], VERTEX = ['Vertex'], ATHENA = ['Athena'], MM = ['Moto Master'], RENTHAL = ['Renthal'],
    MP = ['Motion Pro'], MICHELIN = ['Michelin'];
  var HAUS = {
    'Komplettanlage': AUSPUFF, 'Krümmer': AUSPUFF, 'Endschalldämpfer': AUSPUFF,
    'Luftfilter': ['Twin Air'], 'Ölfilter': ['Hiflofiltro'], 'Zündkerze': ['NGK'],
    'Kolben': VERTEX, 'Top-End-Kit': VERTEX, 'Zylinderkit': VERTEX,
    'Pleuel': ['ProX'],
    'Zylinderdichtsatz': ATHENA, 'Motordichtsatz': ATHENA, 'Dichtungssatz': ATHENA, 'Zylinderkopf-Dichtsatz': ATHENA,
    'Zylinderkopf-Kit': ['VHM'],
    'Bremsbeläge': MM, 'Bremsscheibe': MM,
    'Kette': ['DID'], 'Ritzel': RENTHAL, 'Kettenrad': RENTHAL, 'Kettenkit': RENTHAL,
    'Lenker': RENTHAL, 'Griffe': RENTHAL, 'Hebel': MP, 'Bremshebel': MP, 'Brems- & Kupplungshebel': MP,
    'Gabelbrücke': ['Xtrig'], 'Kunststoffteil': ['UFO'],
    'Reifen': MICHELIN, 'Mousse': MICHELIN
  };
  var fixiert = 0;
  function sortierModus(kinder) {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var s = p.get('sort_by');
    if (s && s !== 'manual') return null;
    if (p.getAll('filter.p.product_type').length) return 'typ';
    /* Seite überwiegend aus einem Bereich (z. B. /collections/auspuff)? */
    var zahl = new Map(), best = null, n = 0;
    kinder.forEach(function (k) {
      var hs = HAUS[k.getAttribute('data-byg-t') || ''];
      if (!hs) return;
      var z = (zahl.get(hs) || 0) + 1;
      zahl.set(hs, z);
      if (z > n) { n = z; best = hs; }
    });
    return best && n >= kinder.length * 0.7 ? best : null;
  }
  function rang(li, gruppe) {
    var hs = gruppe || HAUS[li.getAttribute('data-byg-t') || ''];
    if (!hs) return 0;
    var v = String(li.getAttribute('data-byg-v') || '').toLowerCase();
    for (var i = 0; i < hs.length; i++) if (hs[i].toLowerCase() === v) return i;
    return hs.length;
  }
  function sortieren(grid) {
    var kinder = Array.prototype.slice.call(grid.children);
    if (!kinder.length || kinder.some(function (k) { return !k.classList.contains('data-pagination__item'); })) return;
    var modus = sortierModus(kinder);
    if (!modus) return;
    var gruppe = modus === 'typ' ? null : modus;
    var teil = kinder.slice(Math.min(fixiert, kinder.length));
    var ein = teil.map(function (k, i) { return { k: k, i: i, r: rang(k, gruppe) }; });
    ein.sort(function (a, b) { return a.r - b.r || a.i - b.i; });
    if (!ein.some(function (x, i) { return x.k !== teil[i]; })) return;
    ein.forEach(function (x) { grid.appendChild(x.k); });
  }

  /* ---------- Seite auffüllen (mit gemerktem Bike) ---------- */
  var SCHRITT = 24, MAX_AUTO = 15;
  var ziel = SCHRITT, autoKlicks = 0, eigenerKlick = false, wartet = false, wache = null, neuT = null, gridAlt = null;

  /* Neues Raster (Filter per AJAX gewechselt): wieder bei einer Seite anfangen. */
  function gridPruefen(grid) {
    if (grid === gridAlt) return;
    gridAlt = grid;
    ziel = SCHRITT; autoKlicks = 0; fixiert = 0; wartet = false;
    for (var i = 0; i < grid.children.length; i++) grid.children[i].__bygRaster = 1;
  }
  function passendeKarten() {
    var grid = document.getElementById('data-pagination');
    if (!grid) return 0;
    return Array.prototype.filter.call(grid.children, function (k) {
      return !k.classList.contains('byg-karte--nicht') && !k.classList.contains(NEU);
    }).length;
  }
  function neuFrei() {
    clearTimeout(neuT);
    var n = document.querySelectorAll('#data-pagination > .' + NEU);
    for (var i = 0; i < n.length; i++) n[i].classList.remove(NEU);
  }
  /* Selbst geklickt: pagination.js schreibt die Seite per pushState in die
     Adresse. Hier wird daraus replaceState (die Seitenzahl muss trotzdem in
     die Adresse, byg-garage.js holt danach die Passungsdaten bis zu ihr). */
  function klicken(b) {
    var h = window.history, eigen = Object.prototype.hasOwnProperty.call(h, 'pushState'), push = h.pushState;
    h.pushState = function (s, ti, u) { return h.replaceState(s, ti, u); };
    eigenerKlick = true;
    try { b.click(); } finally {
      if (eigen) h.pushState = push; else delete h.pushState;
      eigenerKlick = false;
    }
  }
  function auffuellen() {
    if (!document.body.classList.contains('byg-nur-passende')) return;
    if (wartet || !weitereSeiten()) return;
    if (document.querySelector('#data-pagination > .' + NEU)) return;
    if (passendeKarten() >= ziel || autoKlicks >= MAX_AUTO) return;
    var b = knopf();
    if (!b) return;
    if (b.disabled || b.classList.contains('btn--loading')) { setTimeout(auffuellen, 300); return; }
    autoKlicks++;
    wartet = true;
    klicken(b);
    clearTimeout(wache);
    wache = setTimeout(function () { wartet = false; neuFrei(); auffuellen(); }, 8000);
  }
  /* Klick des Kunden auf „Mehr anzeigen“: 24 passende mehr als jetzt. */
  document.addEventListener('click', function (e) {
    if (eigenerKlick) return;
    var b = e.target && e.target.closest ? e.target.closest('#component-pagination-loader .js-load-more') : null;
    if (!b) return;
    var grid = document.getElementById('data-pagination');
    ziel = passendeKarten() + SCHRITT;
    autoKlicks = 0;
    fixiert = grid ? grid.children.length : 0;
  }, true);
  /* byg-garage.js hat alle Karten bewertet (auch nach dem Nachladen). */
  document.addEventListener('byg:karten', function () {
    clearTimeout(wache);
    wartet = false;
    var grid = document.getElementById('data-pagination');
    if (grid) { gridPruefen(grid); sortieren(grid); }
    neuFrei();
    setTimeout(auffuellen, 50);
  });

  /* Nachgeladene Karten sofort (vor dem Zeichnen) verstecken, bis sie bewertet sind. */
  function beobachten(liste) {
    var grid = document.getElementById('data-pagination');
    if (grid) gridPruefen(grid);
    var nur = document.body.classList.contains('byg-nur-passende');
    for (var i = 0; i < liste.length; i++) {
      var m = liste[i];
      if (m.type !== 'childList') continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1 || n.__bygRaster || !n.classList.contains('data-pagination__item')) continue;
        n.__bygRaster = 1;
        if (nur && n.parentNode === grid) {
          n.classList.add(NEU);
          clearTimeout(neuT);
          neuT = setTimeout(function () { neuFrei(); auffuellen(); }, 5000);
        }
      }
    }
    bald();
  }

  function bald() {
    clearTimeout(t);
    t = setTimeout(fuellen, 150);
  }

  function start() {
    fuellen();
    new MutationObserver(beobachten).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    window.addEventListener('resize', bald);
    /* byg-garage.js läuft vor diesem Skript (beide defer, Reihenfolge in der
       Section) und kann die erste Seite schon bewertet haben. */
    auffuellen();
    setTimeout(auffuellen, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
